class Attack {
    constructor(startTimestamp) {
        if (new.target === Attack) {
            throw new TypeError("Cannot construct Attack instances directly");
        }

        /**
         * The name of the attack, the class name
         * 
         * @property name
         * @type {string}
         */
        this.name = null;

        /**
         * The timestamp when the attack started
         * 
         * @property startTimestamp
         * @type {number}
         */
        this.startTimestamp = startTimestamp;

        /**
         * The timestamp when the attack ended
         * 
         * @property endTimestamp
         * @type {number}
         */
        this.endTimestamp = null;

        /**
         * The duration of the attack
         * 
         * @property attackDuration
         * @type {number}
         */
        this.attackDuration = null;
        
    }

    /**
     * Initialize the attack
     * 
     * @for Attack
     * @method init
     */
    init() {
        this.name = this.constructor.name;
    }
    
    /**
     * Ends the attack and calculates the duration
     * 
     * @for Attack
     * @method endAttack
     * @param {number} endTimestamp - the timestamp when the attack ended
     */
    end(endTimestamp) {
        this.endTimestamp = endTimestamp;
        this.attackDuration = this.endTimestamp - this.startTimestamp;
    }

    /**
     * Updates the attack data
     * 
     * @for Attack
     * @method update
     */
    update() {
        throw new Error('Method must be implemented by subclass');
    }

}

export default Attack;